import VendorTypesTable from "kinnect-front/FacilityMaintenance/VendorTypes/VendorTypesTable";
import FullWidthLayout from "@/layouts/FullWidthLayout";
import { FacilityMaintenanceVendorType } from "kinnect-models";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { VCard, VSheet } from "vuetify/lib";

export default {
	name: "FacilityMaintenanceVendorTypesPage",

	metaInfo: { title: "Facility Maintenance - Vendor Categories" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		search: "",
		vendorTypes: []
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "add_facility_maintenance_vendor_types" ) ) {
				return {
					icon: "add_circle",
					text: "Add Vendor Category",
					to: { name: "facilityMaintenanceVendorTypeAdd" },
					tooltip: "Add a new vendor category"
				};
			}
		}
	},

	methods: {
		async fetchVendorTypes() {
			this.vendorTypes = await FacilityMaintenanceVendorType.get();
		},

		async fetch() {
			await this.fetchVendorTypes();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<VendorTypesTable
					items={this.vendorTypes}
					loading={this.$wait.is( "get vendor categories" )}
					search={this.search}
				></VendorTypesTable>
			</VCard>
		</FullWidthLayout>;
	}
};
